import { defineComponent, h, ref } from 'vue';
import CannotAddUserSeatsModal from '@/ui/components/modals/CannotAddUserSeatsModal.vue';
import { Button } from '@/ui/components/Button';
import { router } from '@/ui/routes';
import { t } from '@/ui/i18n/i18n';
import { AddUserSeatsModal } from '@/ui/components/modals/AddUserSeatsModal';
import { canAddUser, canSelfServeSubscription } from '@/ui/auth/auth';
import { pushRoute } from '@/ui/helpers';

export const AddUserButton = defineComponent({
  setup() {
    const addUserModal = ref(false);

    const onAddUserClick = (e: MouseEvent) => {
      e.preventDefault();

      if (canAddUser()) {
        pushRoute({ name: 'userCreate' });
      } else {
        addUserModal.value = true;
      }
    };

    const onUserSeatAdded = () => {
      pushRoute({ name: 'userCreate' });
    };

    return function render() {
      return h('div', [
        canSelfServeSubscription.value
          ? h(AddUserSeatsModal, {
            props: {
              active: addUserModal.value,
              ariaRole: 'dialog',
              trapFocus: true,
              destroyOnHide: false,
              ariaModal: true,
            },
            on: {
              close: () => {
                addUserModal.value = false;
              },
              'created:user-seat': onUserSeatAdded,
            },
          })
          : h(CannotAddUserSeatsModal, {
            props: {
              active: addUserModal.value,
            },
            on: {
              close: () => {
                addUserModal.value = false;
              },
            },
          }),
        h(Button, {
          attrs: {
            tag: 'a',
            href: router.resolve({ name: 'userCreate' }).href,
            iconLeft: 'plus',
          },
          nativeOn: {
            click: onAddUserClick,
          },
        }, t('user.add')),
      ]);
    };
  },
});
